module.exports = __webpack_public_path__ + "img/4.c358d7e7.png";